/* lua.js generated code 0.3.0 */

var Event = xClass("Event")
var DEBUG = 0
var EXPORTED_METHODS = sTable(
    "addEventListener",
    "dispatchEvent",
    "removeEventListener",
    "removeEventListenersByTag",
    "removeEventListenersByEvent",
    "removeAllEventListeners",
    "hasEventListener",
    "dumpAllEventListeners"
)
Event.prototype.init_ = function () {
    var self = this
    self.target_ = null
    self.listeners_ = {}
    self.onceHandlers_ = {};
    self.nextListenerHandleIndex_ = 0
}
Event.prototype.bind = function (target) {
    var self = this
    self.init_()
    cc.setmethods(target, self, EXPORTED_METHODS)
    self.target_ = target
}
Event.prototype.unbind = function (target) {
    var self = this
    cc.unsetmethods(target, EXPORTED_METHODS)
    self.init_()
}
Event.prototype.on = function (eventName, listener, tag) {
    var self = this
    assert(type(eventName) === "string" && eventName !== "", "Event:addEventListener() - invalid eventName")
    eventName = string.upper(eventName)
    if (self.listeners_[eventName] == null) {
        self.listeners_[eventName] = {}
    }
    self.nextListenerHandleIndex_ = self.nextListenerHandleIndex_ + 1
    var handle = tostring(self.nextListenerHandleIndex_)
    tag = tag || ""
    self.listeners_[eventName][handle] = sTable(listener, tag)
    if (DEBUG > 1) {
        printInfo("%s [Event] addEventListener() - event: %s, handle: %s, tag: \"%s\"", tostring(self.target_), eventName, handle, tostring(tag))
    }
    return [self.target_, handle]
}
Event.addEventListener = Event.on
Event.prototype.dispatchEvent = function (event) {
    var self = this
    event.name = string.upper(tostring(event.name))
    var eventName = event.name
    if (DEBUG > 1) {
        printInfo("%s [Event] dispatchEvent() - event %s", tostring(self.target_), eventName)
    }
    if (self.listeners_[eventName] == null) {
        return 
    }
    event.target = self.target_
    event.stop_ = false
    event.stop = function (self) {
        self.stop_ = true
    }

    var cacheListeners = {}
    for (var handle in self.listeners_[eventName]) {
        var listener = self.listeners_[eventName][handle]
        if(listener){
            cacheListeners[handle] = listener
        }

    }
    for (var handle in cacheListeners) {
        var listener = cacheListeners[handle]

        if(listener){
            if (DEBUG > 1) {
                printInfo("%s [Event] dispatchEvent() - dispatching event %s to listener %s", tostring(self.target_), eventName, handle)
            }
            // listener[1] = listener
            // listener[2] = tag
            event.tag = listener[2]
            if (rmOnceHandler(self, eventName, handle)) {
                self.removeEventListener(handle);
            }
            listener[1](event)
            if (event.stop_) {
                if (DEBUG > 1) {
                    printInfo("%s [Event] dispatchEvent() - break dispatching for event %s", tostring(self.target_), eventName)
                }
                break
            }
        }

    }
    return self.target_
}
Event.prototype.removeEventListener = function (handleToRemove) {
    var self = this
    for (var eventName in self.listeners_) {
        var listenersForEvent = self.listeners_[eventName]
        for (var handle in listenersForEvent) {
            var _ = listenersForEvent[handle]
            if (handle === handleToRemove) {
                listenersForEvent[handle] = null;
                rmOnceHandler(self, eventName, handle);
                if (DEBUG > 1) {
                    printInfo("%s [Event] removeEventListener() - remove listener [%s] for event %s", tostring(self.target_), handle, eventName)
                }
                return self.target_
            }
        }
    }
    return self.target_
}
Event.prototype.removeEventListenersByTag = function (tagToRemove) {
    var self = this
    for (var eventName in self.listeners_) {
        var listenersForEvent = self.listeners_[eventName]
        if(!listenersForEvent){
            continue
        }
        for (var handle in listenersForEvent) {
            var listener = listenersForEvent[handle]
            if(!listener){
                continue
            }
            // listener[1] = listener
            // listener[2] = tag
            if (listener[2] === tagToRemove) {
                listenersForEvent[handle] = null
                rmOnceHandler(self, eventName, handle);

                if (DEBUG > 1) {
                    printInfo("%s [Event] removeEventListener() - remove listener [%s] for event %s", tostring(self.target_), handle, eventName)
                }
            }
        }
    }
    return self.target_
}
Event.prototype.removeEventListenersByEvent = function (eventName) {
    var self = this
    eventName = string.upper(eventName)
    self.listeners_[eventName] = null
    if (DEBUG > 1) {
        printInfo("%s [Event] removeAllEventListenersForEvent() - remove all listeners for event %s", tostring(self.target_), eventName)
    }
    self.onceHandlers_[eventName] = null;
    return self.target_
}
Event.prototype.removeAllEventListeners = function () {
    var self = this
    self.listeners_ = {}
    if (DEBUG > 1) {
        printInfo("%s [Event] removeAllEventListeners() - remove all listeners", tostring(self.target_))
    }
    self.onceHandlers_ = {}
    return self.target_
}
Event.prototype.hasEventListener = function (eventName) {
    var self = this
    eventName = string.upper(tostring(eventName))
    var t = self.listeners_[eventName] || {}
    for (var _ in t) {
        var __ = t[_]
        return true
    }
    return false
}
Event.prototype.dumpAllEventListeners = function () {
    var self = this
    cc.log("---- Event:dumpAllEventListeners() ----")
    for (var name in self.listeners_) {
        var listeners = self.listeners_[name]
        printf("-- event: %s", name)
        for (var handle in listeners) {
            var listener = listeners[handle]
            printf("--     listener: %s, handle: %s", tostring(listener[1]), tostring(handle))
        }
    }
    return self.target_
}

Event.prototype.once = function (eventName, listener, tag) {
    var self = this
    let [_, handle] = self.on(eventName, listener, tag);
    addToOnceHandler(self, eventName, handle);
    return [_, handle];
}


function addToOnceHandler(self, eventName, handle) {
    eventName = string.upper(eventName);
    let ary = self.onceHandlers_[eventName] || [];
    if (ary.indexOf(handle) < 0) {
        ary.push(handle);
        self.onceHandlers_[eventName] = ary;
    }
}

function rmOnceHandler(self, eventName, handle) {
    eventName = string.upper(eventName);
    let ary = self.onceHandlers_[eventName];
    if (ary) {
        let index = ary.indexOf(handle);
        if(index >= 0) {
            ary.splice(index, 1);
            return true;
        }
    }
    return false;
}

module.exports = Event
